import { useTranslation } from 'react-i18next'
import {
  Button,
  Icon,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { ExpensesDeclarationTableProps } from './ExpensesDeclarationTable'
import dayjs from 'dayjs'
import { DATE_FORMAT_DMY } from '@/constants'
import { ExpenseStatusIndicator } from '@/features/expensesDeclaration/ExpenseStatusIndicator'
import { ReimbursementTypes } from '@/types'

export const ExpensesDeclarationTableBody = ({
  rows,
  showExpenseDeclarationDetails,
}: ExpensesDeclarationTableProps): JSX.Element => {
  const { t } = useTranslation('expensesDeclaration')

  return (
    <>
      <TableBody>
        {rows?.map(
          ({
            id,
            date,
            reimbursement_type,
            amount,
            amount_km,
            description,
            status,
            researcher,
            created_at,
          }) => (
            <TableRow key={id}>
              <TableCell>{id}</TableCell>
              <TableCell>{dayjs(date).format(DATE_FORMAT_DMY)}</TableCell>
              <TableCell>
                {t(`reimbursementTypes.${reimbursement_type}`)}
              </TableCell>
              <TableCell>
                {reimbursement_type === ReimbursementTypes.COURSE_TRAVEL
                  ? `${amount_km} km`
                  : `€ ${amount}`}
              </TableCell>
              <TableCell>{description}</TableCell>
              <TableCell>
                <ExpenseStatusIndicator
                  isSmall={false}
                  status={status}
                  name={t(`indicator.${status}`)}
                />
              </TableCell>
              <TableCell>
                {researcher
                  ? `${researcher.first_name} ${researcher.last_name}`
                  : '-'}
              </TableCell>
              <TableCell>
                {created_at ? dayjs(created_at).format(DATE_FORMAT_DMY) : '-'}
              </TableCell>
              <TableCell align="right">
                <Button
                  variant="text"
                  onClick={() => showExpenseDeclarationDetails(id)}
                  endIcon={
                    <Icon
                      sx={{
                        fontSize: 14,
                        lineHeight: '21px',
                        fontWeight: 600,
                      }}
                    >
                      <ArrowForwardIcon sx={{ height: 14, width: 14 }} />
                    </Icon>
                  }
                >
                  <Typography variant="body2" fontWeight={600}>
                    {t('buttons.view')}
                  </Typography>
                </Button>
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </>
  )
}
